import React from 'react'
import '../App.css'

function Error () {
 
        return (
            <section className="internal-page-wrapper">
                <div className="container">
                    <div className="row h-100 align-item-center Justify-content-center text-center">
                        <div className="col-12">
                            <h1>구현 중!</h1>
                            <img src="https://cdn.pixabay.com/animation/2022/08/07/00/41/00-41-53-965_512.gif"/>
                        </div>
                    </div>
                </div>
            </section>
        )
    
}

export default Error

